// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './CORE/App'
import router from './CORE/router'
import './CORE/styles/main.scss'
import {auth, db} from '@/CUSTOM/helpers/firebase'
import Firebase from 'firebase'
import store from './CUSTOM/store'
import Vueditor from 'vueditor'
import 'vueditor/dist/style/vueditor.min.css'

Vue.config.productionTip = false

let config = {
  fontName: [
    {val: 'decalotyperegular'}, 
    {val: 'akrobatlight'}, 
    {val: 'open_sansbold'}
  ],
  fontSize: ['12px', '14px', '16px', '18px', '0.8rem', '1.0rem', '1.2rem', '1.5rem', '2.0rem'],
  uploadUrl: ''
};

Vue.use(Vueditor, config);

/* eslint-disable no-new */

const unsubscribe = auth.onAuthStateChanged((user => {
  new Vue({
    el: '#app',
    router,
    template: '<App/>',
    components: { App },
    store: store,
    created() {
      auth.onAuthStateChanged((user => {
        if(user) {
          this.$store.dispatch('SET_USER', user)
        } else {
          this.$store.dispatch('UNSET_USER')
        }
      }))
    }
  })
  unsubscribe();
}))






// WEBPACK FOOTER //
// ./src/main.js